import { render, staticRenderFns } from "./ModalCarousel5.vue?vue&type=template&id=27175516&scoped=true&"
import script from "./ModalCarousel5.vue?vue&type=script&lang=js&"
export * from "./ModalCarousel5.vue?vue&type=script&lang=js&"
import style0 from "./ModalCarousel5.vue?vue&type=style&index=0&id=27175516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27175516",
  null
  
)

export default component.exports